import * as React from 'react';

import { DataTable, Table } from '../../components/common';
import { IconButton } from '../../components/buttons';
import { IconEdit, IconDelete } from '../../components/icons';

interface Props {
	className?: string;
	pickListItems: Array<PickListItem>;
	onEdit: (pickListId: string) => void;
	onDelete: (pickListId: string) => void;
}
const PickListItemList: React.StatelessComponent<Props> = props => {
	return (
		<DataTable
			TableComponent={p => <Table isDataTable={true}>{p.children}</Table>}
			columns={[
				{
					accessor: 'id',
					show: false
				},
				{
					Header: 'Code',
					accessor: 'code'
				},
				{
					Header: 'Description',
					accessor: 'description'
				},
				{
					Header: 'Active',
					accessor: 'isActive',
					Cell: (rowInfo: any) => (rowInfo.row.isActive ? 'True' : 'False')
				},
				{
					Header: 'Actions',
					className: 'p-0 td-actions',
					width: 120,
					Cell: (rowInfo: any) => (
						<span>
							<IconButton
								onClick={(e: any) => {
									e.stopPropagation(); // Prevent onClick conflict with tr onclick
									props.onEdit(rowInfo.row.id as string);
								}}
								title="Edit pick list item"
								className="btn-icon-secondary btn-icon-td"
							>
								<IconEdit />
							</IconButton>
							<IconButton
								onClick={(e: any) => {
									e.stopPropagation(); // Prevent onClick conflict with tr onclick
									props.onDelete(rowInfo.row.id as string);
								}}
								title="Delete pick list item"
								className="btn-icon-secondary btn-icon-td"
							>
								<IconDelete />
							</IconButton>
						</span>
					)
				}
			]}
			getTrProps={(state: any, rowInfo: any, column: any) => {
				return {
					className: 'tr interactive',
					onClick: () => props.onEdit(rowInfo.row.id as string)
				};
			}}
			data={props.pickListItems}
			noDataText="No picklists found"
			sortable={true}
		/>
	);
};

export default PickListItemList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/PickList/PickListItemList.tsx